<template>
  <div style="height: 100%">
    <v-app
        v-if="showLogin()"
        id="dealio"
        style="background: #fff; opacity: 0"
        :class="{
        'simple-slow-opacityAN': showLoadingScreen,
        'simple-slow-disappear': loggingIn && !showLoadingScreen,
      }"
    >
      <v-slide-x-transition>
        <login
            v-show="
            (showLogin() || currentPage === '/login') && loginTransitionDelay
          "
            @login="
            (ev) => {
              fetchUserSettings();
              fetchApplicationInstances();
              loginUser(ev, true);
            }
          "
            :loadingAccessTokenDone="loadingAccessTokenDone"
            :sessionExpired="sessionExpired"
            style="height: 100%"
        />
      </v-slide-x-transition>
    </v-app>
    <vue-drawer-layout
        v-else
        :enable="$vuetify.breakpoint.mdAndDown && isMobileOrTablet"
        :drawer-width="240"
        :drawable-distance="300"
        class="accent"
        :class="[
        currentPage.length > 2 ? 'theme_border' : 'supplementary-class',
        loggingOut ? 'simple-slow-disappear' : '',
      ]"
        @mask-click="$refs.drawerLayout.toggle(false)"
        ref="drawerLayout"
        animatable
    >
      <div slot="drawer">
        <v-overlay
            z-index="1"
            color="#edeef2"
            :value="loadingAppUpdate && !loadingAppUpdateFailed"
        ></v-overlay>
        <navigation-bar
            @toggle-drawer="$refs.drawerLayout.toggle(false)"
            @mute="mute"
            :muted="muted"
            :currentPagePath="currentPage"
            :isMobileOrTablet="isMobileOrTablet"
        />
      </div>

      <div :class="mainContentClass" slot="content">
        <v-overlay
            z-index="1"
            color="#edeef2"
            :value="loadingAppUpdate && !loadingAppUpdateFailed"
        ></v-overlay>
        <div @click="soundsDisabled ? (soundsDisabled = false) : ''">
          <v-app id="dealio" class="simple-slow-opacityAN">
            <img
                class="hiddenimage-fetch-for-offline"
                src="/img/dynamic-src-images/errors/oops-error.svg"
                alt="Error"
            />
            <img
                class="hiddenimage-fetch-for-offline"
                src="/img/dynamic-src-images/price-guard.svg"
                alt="Price Guard"
            />
            <img
                class="hiddenimage-fetch-for-offline"
                src="/img/dynamic-src-images/trade-watcher.svg"
                alt="Trade Watcher"
            />
            <navigation-bar
                v-if="$vuetify.breakpoint.lgAndUp"
                :currentPagePath="currentPage"
            />
            <div class="text-center"></div>
            <v-app-bar
                :height="$vuetify.breakpoint.smAndDown ? '56' : '60'"
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                flat
                app
                dark
                fixed
                :dense="false"
                class="app-bar"
            >
              <div class="toolbar-left justify-start">
                <v-toolbar-title>
                  <v-row class="my-0">
                    <v-avatar
                        @click="toggleDrawer"
                        class="clickable"
                        :style="
                      $vuetify.breakpoint.width > 957
                        ? 'margin-left: 12px;'
                        : 'margin-left: 12px;'
                    "
                        :size="$vuetify.breakpoint.smAndDown ? '56px' : '60px'"
                        tile
                    >
                      <v-icon
                          class="clickableAndZoom_menuIcon"
                          style="font-size: 24px !important"
                      >fa-solid fa-bars
                      </v-icon
                      >
                    </v-avatar>
                  </v-row>
                </v-toolbar-title>
              </div>
              <div class="toolbar-center justify-center">
                <transition name="fade" mode="out-in">
                  <div v-if="$vuetify.breakpoint.smAndUp" key="topBarLogoKey">
                    <v-img
                        class="mb-1"
                        max-width="125"
                        src="/img/dynamic-src-images/logos/SVG-logo-dark-all-white.svg"
                    ></v-img>
                  </div>
                </transition>
              </div>
              <div class="toolbar-right justify-end">
                <v-btn
                    :color="$vuetify.theme.dark ? 'primary' : 'white'"
                    text
                    icon
                    aria-label="user"
                    @click="userPanel = !userPanel"
                    v-model="userPanel"
                >
                  <v-icon style="font-size: 1.3rem">fas fa-user</v-icon>
                </v-btn>
                <v-menu
                    v-model="userPanel"
                    close-on-content-click
                    content-class="user-panel"
                    auto
                    :position-x="userPanelPosition.x"
                    :position-y="userPanelPosition.y"
                >
                  <div style="min-width: 160px" class="accent user-panel-content">
                    <v-row class="mx-0 pt-3" justify="center">
                      <v-btn @click="goToUserSettings" icon x-large>
                        <v-avatar color="primary">
                          <v-icon style="font-size: 21px" dark>
                            {{
                              isAdmin ? "fas fa-users-cog" : "fas fa-user-circle"
                            }}
                          </v-icon>
                        </v-avatar>
                      </v-btn>
                    </v-row>
                    <v-row justify="center" class="py-2">
                      {{ getUserInfo.name }}
                    </v-row>
                    <v-row justify="center">
                      <v-col style="font-size: 12px" class="text-center py-0">
                        ({{ isAdmin ? "Admin" : "User" }})
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-btn @click="logout" color="primary" text>
                        <v-icon small color="primary" class="mr-2"
                        >fas fa-sign-out-alt
                        </v-icon
                        >
                        Log Out
                      </v-btn>
                    </v-row>
                  </div>
                </v-menu>
                <v-btn
                    :color="$vuetify.theme.dark ? 'primary' : 'white'"
                    text
                    icon
                    @click="mute"
                    aria-label="volume"
                >
                  <template v-if="!this.muted">
                    <v-icon v-if="this.volume >= 50">volume_up</v-icon>
                    <v-icon v-else-if="this.volume > 10">volume_down</v-icon>
                    <v-icon v-else>volume_mute</v-icon>
                  </template>
                  <v-icon v-show="this.muted">volume_off</v-icon>
                </v-btn>
                <v-badge
                    :content="
                  TWAlertsTotalLength < 100 ? TWAlertsTotalLength : '99+'
                "
                    :value="TWAlerts.length > 0"
                    offset-y="20"
                    offset-x="20"
                    :color="$vuetify.theme.dark ? 'primary' : 'white'"
                    class="notifications-badge"
                    style="font-size: 12px"
                >
                  <v-btn
                      :disabled="TWAlerts.length < 1"
                      icon
                      aria-label="notifications"
                      :color="$vuetify.theme.dark ? 'primary' : 'white'"
                      @click="showNotificationsPanel"
                  >
                    <v-icon style="font-size: 20px"
                    >icon-new-notification-24x24
                    </v-icon
                    >
                  </v-btn>
                </v-badge>
                <v-menu
                    v-model="notificationsPanel"
                    transition="scroll-x-transition"
                    :close-on-content-click="false"
                    :content-class="
                  $vuetify.breakpoint.xsOnly
                    ? 'notifications-panel-xs notifications-panel-scroll'
                    : 'notifications-panel notifications-panel-scroll'
                "
                    :position-x="userPanelPosition.x"
                    :position-y="userPanelPosition.y"
                >
                  <div class="accent">
                    <div
                        id="notif_history"
                        :key="notifPanelRenderKey"
                        @scroll="isAtBottom = checkIfHistoryBottomed()"
                        style="
                      max-height: 300px;
                      max-width: 234px;
                      overflow-y: auto;
                      overflow-x: hidden;
                    "
                    >
                      <div
                          v-for="(alert, index) in TWAlerts"
                          :key="alert.id"
                          :class="{
                        'clearAlert-wrapper': alert.clear,
                        'alert-wrapper': alertsToClearLength < 30,
                        'alert-wrapper-fast': alertsToClearLength >= 30,
                      }"
                          style="width: 600px"
                          class="alert-wrapper"
                      >
                        <v-lazy
                            :options="{
                          threshold: 0.1,
                        }"
                            min-height="69"
                            transition="fade-transition"
                        >
                          <div>
                            <div
                                :class="{
                              clearAlert: alert.clear,
                              'notification-panel-alert':
                                alertsToClearLength < 30,
                              'notification-panel-alert-fast':
                                alertsToClearLength >= 30,
                            }"
                                style="
                              border-radius: 12px;
                              font-size: 12.5px;
                              width: 216px;
                            "
                                class="notification-history-section mt-1 pr-2"
                            >
                              <v-row class="ma-0 pl-2" style="padding-top: 2px">
                                <p
                                    class="mb-0 ml-1"
                                    style="letter-spacing: 0.6px"
                                >
                                  Trade Watcher
                                </p>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-on="on"
                                        v-bind="attrs"
                                        @click="acknowledge(alert.id)"
                                        :height="16"
                                        x-small
                                        icon
                                    >
                                      <i
                                          class="far fa-check-circle"
                                          style="
                                        height: 12px;
                                        font-size: 13px;
                                        margin-right: 2px;
                                      "
                                      ></i>
                                    </v-btn>
                                  </template>
                                  <span>Confirm</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-on="on"
                                        v-bind="attrs"
                                        @click="focusOnAlert(alert.id, index)"
                                        :height="16"
                                        x-small
                                        icon
                                    >
                                      <i
                                          class="fas fa-share"
                                          style="font-size: 12px"
                                      ></i>
                                    </v-btn>
                                  </template>
                                  <span>See more</span>
                                </v-tooltip>
                              </v-row>
                              <v-row class="ma-0" style="height: 43px">
                                <v-icon
                                    class="pl-1 mb-2"
                                    color="red"
                                    style="
                                  float: left;
                                  font-size: 14px;
                                  margin: 8px;
                                  margin-left: 9px;
                                  margin-top: 9px;
                                "
                                >fas fa-exclamation-triangle
                                </v-icon
                                >
                                <p
                                    class="mb-1 mt-1 notification-panel"
                                    style="
                                  max-width: 160px;
                                  float: left;
                                  margin: 4px;
                                  margin-right: 0;
                                  font-size: 11px;
                                  letter-spacing: 0.4px;
                                  line-height: 1.2;
                                "
                                >
                                  {{ alert.message }}
                                </p>
                              </v-row>
                            </div>
                            <v-row
                                :class="{ clearAlert: alert.clear }"
                                style="width: 234px; font-size: 10.5px"
                                justify="end"
                            >
                              <p class="mb-0 mr-5">{{ alert.createdOn }}</p>
                            </v-row>
                          </div>
                        </v-lazy>
                      </div>
                      <v-btn
                          @click="loadMoreHistory(true)"
                          v-if="
                        (isAtBottom && allAlertsLoaded) ||
                        (!loadingHistory && TWAlerts.length < 4) ||
                        (isAtBottom && !loadingHistory)
                      "
                          :class="{ 'hide-slow': clearingAllAlerts }"
                          class="text-center mb-0 mt-2"
                          style="font-size: 12px; width: 100%; transition: 0.5s"
                          text
                      >
                        Load more...
                      </v-btn>
                      <v-row
                          v-else-if="!clearingAllAlerts"
                          justify="center"
                          class="mx-0 my-2"
                      >
                        <v-progress-circular
                            :size="20"
                            width="2"
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                      </v-row>

                      <div
                          class="accent"
                          style="width: 224px; position: fixed; bottom: 0"
                      >
                        <div class="row mx-0 mb-1" style="height: 17px">
                          <p
                              class="mb-0 ml-2"
                              style="font-size: 12px; margin-top: 2px"
                          >
                            {{ TWAlerts.length }}/{{ TWAlertsTotalLength }}
                          </p>
                          <v-spacer></v-spacer>
                          <v-btn
                              @click="changeAlertsSort"
                              text
                              rounded
                              x-small
                              class="px-1"
                              style="
                            font-size: 13px !important;
                            text-transform: none !important;
                          "
                          >
                            <p class="mb-0" style="letter-spacing: 0">
                              Sort by time
                            </p>
                            <v-icon class="ml-1" :style="sortIconStyle">
                              {{ sortIcon }}
                            </v-icon>
                          </v-btn>

                          <v-btn
                              @click="clearNotifications"
                              text
                              rounded
                              x-small
                              class="px-1"
                              style="
                            font-size: 13px !important;
                            text-transform: none !important;
                          "
                          >
                            <p class="mb-0" style="letter-spacing: 0">Clear</p>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                    <div class="row mr-0" style="height: 17px"></div>
                  </div>
                </v-menu>
                <v-switch
                    class="ml-2"
                    dark
                    :color="$vuetify.theme.dark ? 'primary' : ''"
                    style="padding-top: 25px"
                    v-model="themeSwitch"
                    aria-label="theme switcher"
                ></v-switch>
              </div>
            </v-app-bar>

            <v-main
                id="main-wrapper"
                v-resize="onResize"
                :style="getContentPadding"
                style="overflow-x: hidden"
                class="accent"
            >
              <v-container
                  class="pa-0 ma-0"
                  style="height: 100% !important"
                  fluid
              >
                <transition name="fade">
                  <router-view
                      ref="routerView"
                      :windowSizeY="windowSizeY"
                      :windowSizeX="windowSizeX"
                      :settingsProfileExists="settingsProfileExists"
                      :isNotDesktop="isMobileOrTablet"
                      :previousPage="previousPage"
                      :pageReloaded="pageReloaded"
                      :showUserSettings="showUserSettings"
                      :currentEpochTime="currentEpochTime"
                      :removeExpiredDataAfter="removeExpiredDataAfter"
                      :selectedProfile="selectedProfile"
                      :settingsLoaded="settingsLoaded"
                      :connectionLost="connectionLost"
                      :tradeWatcherMute="tradeWatcherMute"
                      :priceGuardMute="priceGuardMute"
                      :priceguarDataExpiring="removeExpiredData"
                      @ignored-pg-prices-change="ignoredPGPricesChange"
                      @mutate-settings-profile-exists="
                      settingsProfileExists = $event
                    "
                      @mutate-selected-profile="
                      selectedProfile = $event
                    "
                      @set-new-settings="setNewSettings"
                      @analytics-empty="changeAnalyticsColor"
                      @update-alerts-total="updateAlertsTotal"
                      @analytics-tab-change="analyticsTabChange"
                      @update-app-state="updateAppStateRemotelyAndLocally"
                      @mute-trade-watcher="muteTradeWatcher"
                      @mute-priceguard="mutePriceGuard"
                      @play-sound="playSound"
                      @set-priceguard-expiring="assignDataExpiring"
                  ></router-view>
                </transition>
              </v-container>
            </v-main>
            <v-snackbar
                v-if="
                notificationSupported &&
                !notificationsForbidden &&
                soundsDisabled &&
                !connectionLost
              "
                id="secondary-snackbar"
                @click="soundsDisabled = false"
                color="primary"
                :class="[
                $vuetify.breakpoint.xsOnly
                  ? 'mobile_alerts snackbar-xs-margin'
                  : 'black--text',
                snackbarPadding,
              ]"
                :timeout="-1"
                multi-line
                v-model="soundsDisabled"
                left
                width="344"
                content-class="v-snack-msg"
            >
              <v-row>
                <v-col cols="2" class="pa-0 text-center">
                  <v-icon class="mt-2 ml-1" color="black"
                  >fas fa-exclamation-triangle
                  </v-icon
                  >
                </v-col>
                <v-col cols="10" class="pa-0">
                  <p class="black--text mb-0">
                    Sounds are disabled. Please click this alert
                    <br/>or anywhere on the screen to enable them.
                  </p>
                </v-col>
              </v-row>
            </v-snackbar>
            <v-snackbar
                v-else-if="notificationsForbidden && !connectionLost"
                id="secondary-snackbar"
                :timeout="-1"
                multi-line
                v-model="notificationsForbidden"
                left
                content-class="v-snack-no-notif-msg-expand"
                class="v-snack-no-notif-msg-outer"
                color="white"
            >
              <v-row class="mx-0">
                <v-col cols="2" class="pa-0 text-center" align-self="center">
                  <v-icon class="ml-1" color="black">fas fa-bell-slash</v-icon>
                </v-col>
                <v-col cols="7" class="pa-0" align-self="center">
                  <p class="black--text mb-0">
                    Notifications are blocked. You<br/>won't be notified of any
                    events.
                  </p>
                </v-col>
                <v-col cols="3" class="px-0">
                  <v-btn
                      @click="showNotifTutorial = !showNotifTutorial"
                      small
                      light
                      text
                  >enable
                  </v-btn
                  >
                </v-col>
              </v-row>

              <v-hover v-slot="{ hover }">
                <v-icon
                    @click="
                    soundsDisabled = false;
                    notificationsForbidden = false;
                  "
                    small
                    :class="hover ? 'grey--text text--darken-2' : 'black--text'"
                    class="absolute-force"
                    style="top: 4px; right: 4px; font-size: 14px"
                >
                  far fa-times-circle
                </v-icon>
              </v-hover>
            </v-snackbar>
            <v-snackbar
                v-else-if="!notificationSupported && !connectionLost"
                id="iphone-snackbar"
                :timeout="-1"
                multi-line
                v-model="soundsDisabled"
                left
                content-class="v-snack-no-notif-msg-expand"
                class="v-snack-no-notif-msg-outer"
                color="primary"
            >
              <v-row class="mx-0" style="height: 65px !important">
                <v-col cols="2" class="pa-0 text-center" align-self="center">
                  <v-icon class="ml-1" color="black">fas fa-bell-slash</v-icon>
                </v-col>
                <v-col cols="9" class="pa-0" align-self="center">
                  <p class="black--text mb-0">
                    Your device doesn't support notifications. You won't be
                    notified if you exit the app.
                  </p>
                </v-col>
              </v-row>
            </v-snackbar>

            <v-snackbar
                id="iphone-snackbar"
                :timeout="-1"
                multi-line
                v-model="appUpdateAvailable"
                left
                content-class="v-snack-app-update new-version-snack"
                class="v-snack-app-update-outer"
                :class="
                loadingAppUpdateFailed ? 'update-failed' : 'currently-updating'
              "
                color="info"
            >
              <v-row class="mx-0 pl-5 pr-1" style="height: 65px !important">
                <v-col
                    :cols="loadingAppUpdateFailed ? 11 : 8"
                    class="pa-0"
                    align-self="center"
                >
                  <p v-if="!loadingAppUpdateFailed" class="white--text mb-0">
                    A new version of Dealio is available!
                  </p>
                  <div v-else>
                    <p class="white--text mb-0">Oops! Couldn't update.</p>
                    <p class="white--text mb-0">
                      You can update manually with Ctrl+F5.
                    </p>
                  </div>
                </v-col>
                <v-col
                    v-if="!loadingAppUpdateFailed"
                    cols="3"
                    class="pa-0 text-center"
                    align-self="center"
                >
                  <v-btn
                      v-if="!loadingAppUpdate"
                      color="#b5d0ff"
                      text
                      @click="updateApp"
                      class="px-2"
                      style="margin-bottom: 2px; margin-left: -2px"
                  >UPDATE
                  </v-btn
                  >
                  <v-progress-circular
                      v-else
                      :size="20"
                      width="2"
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                  <v-spacer/>
                </v-col>
                <v-col cols="1" class="pa-0">
                  <v-btn
                      icon
                      @click="dismissAppUpdate"
                      color="grey lighten-3"
                      style="margin-top: 5px; margin-left: -10px"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-snackbar>

            <v-snackbar
                color="info"
                :class="[
                $vuetify.breakpoint.xsOnly
                  ? 'mobile_alerts snackbar-xs-margin'
                  : 'black--text',
                snackbarPadding,
              ]"
                class="small-snack"
                :timeout="-1"
                multi-line
                left
                width="320"
                content-class="v-snack-msg"
                v-model="connectionLost"
            >
              <v-row>
                <v-col
                    cols="2"
                    class="text-right pa-0"
                    style="display: flex; align-items: center; height: 32px"
                >
                  <v-icon
                      id="no-connection-icon"
                      class="ml-7"
                      style="margin-bottom: 2px !important"
                      small
                  >fas fa-wifi
                  </v-icon
                  >
                </v-col>
                <v-col
                    cols="10"
                    class="pa-0"
                    style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 32px;
                  "
                >
                  <p
                      class="white--text mb-0 mr-2"
                      style="font-size: 16px; margin-left: -4px"
                  >
                    No server connection available
                  </p>
                </v-col>
              </v-row>
            </v-snackbar>

            <notifier
                :soundsDisabled="soundsDisabled"
                :mobileNotStandalone="mobileNotStandalone"
                :isMobileOrTablet="isMobileOrTablet"
                :connectionLost="connectionLost"
                :appUpdateAvailable="appUpdateAvailable"
            ></notifier>
            <div id="audio">
              <audio
                  id="my-audio"
                  :loop="innerLoop"
                  :muted="true"
                  ref="audiofile"
                  preload="auto"
                  style="display: none"
              ></audio>
            </div>

            <v-dialog
                transition="scroll-x-transition"
                overlay-color="grey darken-2"
                v-model="showNotifTutorial"
                width="850px"
                persistent
            >
              <v-card
                  :class="{ 'pl-0': $vuetify.breakpoint.xsOnly }"
                  class="accent pa-4 pr-0"
              >
                <v-btn
                    @click="showNotifTutorial = !showNotifTutorial"
                    icon
                    small
                    class="absolute"
                    style="top: 12px; right: 12px"
                >
                  <i class="fas fa-times" style="font-size: 0.875rem"></i>
                </v-btn>
                <v-card-title
                    :class="{ 'ml-4': $vuetify.breakpoint.xsOnly }"
                    class="pa-0 mb-1 ml-2"
                    style="margin-top: -6px"
                >Enabling device notifications
                </v-card-title
                >
                <div style="width: 100%; height: 520px; overflow-y: auto">
                  <div v-if="!isMobileOrTablet">
                    <div class="v-stepper__step v-stepper__step--active">
                      <span class="v-stepper__step__step primary">1</span>
                      <div class="v-stepper__label">Open Site Info</div>
                    </div>
                    <div
                        style="
                        padding: 24px;
                        border-left: 1px solid rgba(255, 255, 255, 0.12);
                        margin-left: 36px;
                      "
                    >
                      <v-img
                          width="480px"
                          src="./assets/other-images/site-info.png"
                      ></v-img>
                    </div>
                    <div class="v-stepper__step v-stepper__step--active">
                      <span class="v-stepper__step__step primary">2</span>
                      <div class="v-stepper__label">Allow Notifications</div>
                    </div>
                    <div
                        style="
                        padding: 24px;
                        border-left: 1px solid rgba(255, 255, 255, 0.12);
                        margin-left: 36px;
                      "
                    >
                      <v-img
                          width="480px"
                          src="./assets/other-images/allow-notifications.png"
                      ></v-img>
                    </div>
                    <div class="v-stepper__step v-stepper__step--active">
                      <span class="v-stepper__step__step primary">3</span>
                      <div class="v-stepper__label">
                        Reload the page and that's it!
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div class="v-stepper__step v-stepper__step--active">
                      <span class="v-stepper__step__step primary">1</span>
                      <div class="v-stepper__label">Open Site Info</div>
                    </div>

                    <div
                        style="
                        padding: 24px;
                        border-left: 1px solid rgba(255, 255, 255, 0.12);
                        margin-left: 36px;
                      "
                    >
                      <v-img
                          width="480px"
                          src="./assets/other-images/mobile/step-1.jpg"
                      ></v-img>
                    </div>

                    <div class="v-stepper__step v-stepper__step--active">
                      <span class="v-stepper__step__step primary">2</span>
                      <div class="v-stepper__label">Open Site Settings</div>
                    </div>
                    <div
                        style="
                        padding: 24px;
                        border-left: 1px solid rgba(255, 255, 255, 0.12);
                        margin-left: 36px;
                      "
                    >
                      <v-img
                          width="480px"
                          src="./assets/other-images/mobile/step-2.jpg"
                      ></v-img>
                    </div>

                    <div class="v-stepper__step v-stepper__step--active">
                      <span class="v-stepper__step__step primary">3</span>
                      <div class="v-stepper__label">
                        Open Notifications Settings
                      </div>
                    </div>
                    <div
                        style="
                        padding: 24px;
                        border-left: 1px solid rgba(255, 255, 255, 0.12);
                        margin-left: 36px;
                      "
                    >
                      <v-img
                          width="480px"
                          src="./assets/other-images/mobile/step-3.jpg"
                      ></v-img>
                    </div>

                    <div class="v-stepper__step v-stepper__step--active">
                      <span class="v-stepper__step__step primary">4</span>
                      <div class="v-stepper__label">Enable Notifications</div>
                    </div>
                    <div
                        style="
                        padding: 24px;
                        border-left: 1px solid rgba(255, 255, 255, 0.12);
                        margin-left: 36px;
                      "
                    >
                      <v-img
                          width="480px"
                          src="./assets/other-images/mobile/step-4.jpg"
                      ></v-img>
                    </div>

                    <div class="v-stepper__step v-stepper__step--active">
                      <span class="v-stepper__step__step primary">5</span>
                      <div class="v-stepper__label">
                        Reload the page and that's it!
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-dialog>
            <profile-selection-dialog
                v-model="profileSelectionDialog"
                :profiles="configurationProfiles"
                :deviceType="deviceType"
                :noProfilesExist="noProfilesExist"
                :isMobileOrTablet="isMobileOrTablet"
                :isAdmin="isAdmin"
                :getUserInfo="getUserInfo"
                @delete-unsaved-profile="deleteUnsavedProfile"
                @refresh-user-profiles="refreshUserProfiles"
                @new-profile-created="newProfileCreated"
                @profile-selected="applySelectedProfile"
            />
          </v-app>
        </div>
      </div>
    </vue-drawer-layout>
  </div>
</template>

<script>
import axios from "axios";
import Login from "@/components/Login";
import AudioPlayer from "@/components/AudioPlayer";
import {
  ALERT_SORTS,
  NOTIF_PANEL_HEIGHTS,
  APP_STATE_SECTIONS,
} from "./utilities/enums";
import pushNotificationPage from "./plugins/notifier";
import NavigationBar from "@/components/NavigationBar";
import {mapMutations, mapGetters, mapActions} from "vuex";
import {defaultSettings} from "./utilities/DefaultObjects";
import {messageService} from "@/services/AnalyticsService";
import {PriceWatcherMessageService} from "@/services/PricewatcherService";
import PriceguardPreprocessor from "@/utilities/Priceguard-Preprocessor";
import ProfileSelectionDialog from "@/components/ProfileSelectionDialog";
import {
  source,
  refreshCancelToken,
  SettingsService,
  AuthenticationService,
  UserService,
  TradeWatcherService,
} from "@/services/ApiService";
import {NOTIFICATION_TYPES} from "./utilities/enums";
import {events} from "./plugins/events";
import {refineBaseURI} from "@/utilities/client-uri";

var sse;
let accessToken = "";
var channel;

if (!iOS()) {
  channel = new BroadcastChannel("BroadcastChannel");
} else {
  channel = null;
}

export default {
  name: "App",
  components: {NavigationBar, Login, ProfileSelectionDialog},
  mixins: [AudioPlayer],
  computed: {
    notificationSupported() {
      return "Notification" in window;
    },
    sortIconStyle() {
      if (this.alertsSort === ALERT_SORTS.DESC)
        return "font-size: 12px; margin-top:2px; color: #47BD96;";
      else if (this.alertsSort === ALERT_SORTS.ASC)
        return "font-size: 12px; margin-top:2px; color: #47BD96;";
      else return "font-size: 12px; margin-top:2px;";
    },
    sortIcon() {
      return this.alertsSort === ALERT_SORTS.DESC
          ? "fas fa-long-arrow-alt-up"
          : "fas fa-long-arrow-alt-down";
    },
    userPanelPosition() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return {
          x: this.$vuetify.breakpoint.width - 246,
          y: this.$vuetify.breakpoint.mdAndUp ? 61 : 57,
        };
      } else return {x: this.$vuetify.breakpoint.width, y: 56};
    },
    mainContentClass() {
      let contentClasses =
          this.$vuetify.breakpoint.smAndDown ||
          (this.$vuetify.breakpoint.mdAndUp &&
              this.$vuetify.breakpoint.height < 755)
              ? "main-content-scrollable"
              : "main-content";
      contentClasses += this.$vuetify.theme.dark ? " main-dark" : " main-light";
      return contentClasses;
    },
    getAccess() {
      return accessToken;
    },
    themeSwitch: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(v) {
        this.updatePWATheme(v);
        this.updateAppStateRemotelyAndLocally({
          section: APP_STATE_SECTIONS.DARK,
          mutation: v,
        });
        this.$vuetify.theme.dark = v;
      },
    },
    snackbarPadding() {
      return this.mobileNotStandalone
          ? "disableNotifications-fix"
          : this.isMobileOrTablet
              ? "disableNotifications-fix-tablet"
              : "supplementary-class";
    },
    mobileNotStandalone() {
      return (
          !navigator.standalone &&
          !window.matchMedia("(display-mode: standalone)").matches &&
          this.$vuetify.breakpoint.xsOnly
      );
    },
    notificationRequestAccepted() {
      if ("Notification" in window) {
        return Notification.permission === "granted";
      } else {
        return false;
      }
    },
    lgAndUp() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    dataExpirationCycle() {
      if (
          this.getSettings === undefined ||
          !Object.keys(this.getSettings).length
      ) {
        return defaultSettings.applications.priceguard.dataExpirationCycle;
      } else {
        return this.getSettings.applications.priceguard.dataExpirationCycle;
      }
    },
    removeExpiredDataAfter() {
      if (
          this.getSettings === undefined ||
          !Object.keys(this.getSettings).length
      ) {
        return defaultSettings.applications.priceguard.removeExpiredDataAfter;
      } else {
        return this.getSettings.applications.priceguard.removeExpiredDataAfter;
      }
    },
    priceOldAfter() {
      if (
          this.getSettings === undefined ||
          !Object.keys(this.getSettings).length
      )
        return defaultSettings.applications.priceguard.priceOldAfter;
      else return this.getSettings.applications.priceguard.priceOldAfter;
    },
    isMobileOrTablet() {
      return navigator.userAgent.match(
          /Android|BlackBerry|webOS|midori|Tablet|phone|Windows Phone|mobile|iPhone|iPad|iPod|Opera Mini|IEMobile/i
      ) != null;
    },
    getContentPadding() {
      var paddingTop60 = " padding-top: 60px;";
      var paddingTop56 = " padding-top: 56px;";

      if (this.$vuetify.breakpoint.mdAndDown) {
        if (this.$vuetify.breakpoint.smAndDown) {
          return paddingTop56;
        } else {
          return paddingTop60;
        }
      } else {
        if (this.$store.getters.getMiniDrawer) {
          return "padding-left: 240px; padding-bottom: 0;" + paddingTop60;
        } else {
          return "padding-left: 60px; padding-bottom: 0;" + paddingTop60;
        }
      }
    },
    deviceType() {
      if (this.isMobileOrTablet) {
        if (
            this.$vuetify.breakpoint.width < 600 ||
            this.$vuetify.breakpoint.height < 600
        )
          return "Mobile";
        else return "Tablet";
      } else if (this.isMobileOrTablet === false) {
        if (
            this.$vuetify.breakpoint.width < 1441 &&
            this.$vuetify.breakpoint.height < 1441
        )
          return "Desktop";
        // return "Laptop";
        else return "Desktop";
      } else return null;
    },
    ...mapGetters(["getSettings"]),
    ...mapGetters(["getSpecificSetting"]),
    ...mapGetters(["getPriceGuardEvents"]),
    ...mapGetters(["getUserInfo", "getTokenExpirationTime", "isAdmin"]),
    ...mapGetters("instances", ["getApplicationInstanceNameByIdentity"]),
  },
  data() {
    return {
      tradeWatcherMute: false,
      priceGuardMute: false,
      settingsLoaded: false,
      selectedProfile: {
        configuration: {
          device: "Desktop",
        },
        username: null,
      },
      noProfilesExist: false,
      configurationProfiles: [],
      profileSelectionDialog: false,
      loadingAppUpdateFailed: false,
      loadingAppUpdate: false,
      appUpdateAvailable: false,
      connectionLost: false,
      firstSSEError: false,
      test: true,
      lastPingReceived: null,
      loadingIgnoredItems: true,
      currentEpochTime: 0,
      disableAlertsBadge: false,
      alertsToClearLength: 0,
      clearingAllAlerts: false,
      notifPanelRenderKey: 0,
      lastFetchedAlertsPage: null,
      NOTIF_PANEL_HEIGHTS: NOTIF_PANEL_HEIGHTS,
      alertsSort: ALERT_SORTS.NONE,
      TWAlerts: [],
      TWAlertsTotalLength: null,
      showNotifTutorial: false,
      notificationsForbidden: false,
      showUserSettings: false,
      notificationsPanel: false,
      userPanel: false,
      pageReloaded: true,
      initialIgnoredPGPrices: [],
      SSEConnected: true,
      fetchingANs: false,
      loggingIn: false,
      previousPage: "",
      loggingOut: false,
      loadingHistory: false,
      allAlertsLoaded: false,
      isAtBottom: false,
      notificationsTabs: 0,
      sessionExpired: false,
      showLoadingScreen: false,
      loginTransitionDelay: false,
      loadingAccessTokenDone: false,
      screenOrientationType: null,
      windowSizeY: 0,
      windowSizeX: 0,
      soundsDisabled: false,
      notificationPage: {},
      removeExpiredData: false,
      currentPage: window.location.pathname,
      analyticsIsEmpty: false,
      settingsProfileExists: false,
      currentTableAgentIds: [],
      deviceSortEnum: {
        Desktop: 0,
        Laptop: 1,
        Tablet: 2,
        Mobile: 3,
      },
    };
  },
  methods: {
    applyTWState() {
      let tradewatcherSetting = this.getSpecificSetting({
        section: "applicationState",
        innerSection: APP_STATE_SECTIONS.TRADEWATCHER,
      });

      if (
          !tradewatcherSetting ||
          (typeof tradewatcherSetting == "object" &&
              !tradewatcherSetting.hasOwnProperty("mute"))
      )
        return;

      this.tradeWatcherMute = tradewatcherSetting.mute;
    },
    applyPGState() {
      // Get previously saved ignored PG prices state

      let priceguardSetting = this.getSpecificSetting({
        section: "applicationState",
        innerSection: APP_STATE_SECTIONS.PRICEGUARD,
      });

      this.priceGuardMute = priceguardSetting.mute;
      this.removeExpiredData = priceguardSetting.expiring;

      if (
          !priceguardSetting ||
          (typeof priceguardSetting == "object" &&
              !priceguardSetting.hasOwnProperty("ignoredItems"))
      ) {
        return;
      }

      this.initialIgnoredPGPrices = priceguardSetting.ignoredItems;

      this.loadingIgnoredItems = false;

      // localForage.getItem("PGignoredItems", (err, value) => {
      //   if (value != null) {
      //     this.initialIgnoredPGPrices = value;
      //   }
      //   this.loadingIgnoredItems = false;
      // });
    },
    setEventListeners() {
      if (!this.audioEventListenersState()) {
        setTimeout(() => {
          this.addAudioElementListeners();
        }, 500);
      }
    },
    updateAppStateRemotelyAndLocally(options) {
      this.updateApplicationState(options);

      let updatedSettings = JSON.parse(JSON.stringify(this.getSettings));

      this.updateAppSettingsRemotely({settings: updatedSettings});
    },
    muteTradeWatcher() {
      this.tradeWatcherMute = !this.tradeWatcherMute;

      let options = {
        section: APP_STATE_SECTIONS.TRADEWATCHER,
        innerSection: "mute",
        mutation: this.tradeWatcherMute,
      };
      this.updateAppStateRemotelyAndLocally(options);
    },
    mutePriceGuard() {
      this.priceGuardMute = !this.priceGuardMute;

      let options = {
        section: APP_STATE_SECTIONS.PRICEGUARD,
        innerSection: "mute",
        mutation: this.priceGuardMute,
      };
      this.updateAppStateRemotelyAndLocally(options);
    },
    // updateAppSettingsRemotely({ settings, section, recursive }) {
    updateAppSettingsRemotely({settings, recursive}) {
      let profileId = parseInt(
          localStorage.getItem("currentSettingsProfileId"),
          10
      );

      if (!profileId && profileId !== 0) {
        if (this.isAdmin)
          console.log(
              "Oops! No profile ID found when updating the application state."
          );
        return;
      }

      let requestStatus = "200";

      SettingsService.put(profileId, settings)
          .then(() => {
            // DESCRIPTION: IMPORTANT
            // It has been set that first you update the settings locally and then remotely (not the opposite)
            // The reason is because some components values are binded to vuex values. So if the API call takes long
            // The user will be waiting for the change in the UI until the API call finishes
            // this.updateSpecificSetting({
            //   sections: section,
            //   value: settings.applicationState.analytics,
            // });
          })
          .catch((error) => {
            if (
                error.hasOwnProperty("message") &&
                error.message.search("404") !== -1 &&
                !recursive
            ) {
              requestStatus = "404";
              // Get the configuration for the current type of device
              return SettingsService.getMe({
                params: {
                  device:
                      localStorage.getItem("selected-device-type") || "Desktop",
                },
              });
              // return SettingsService.getMe({ params: { device: "Desktop" } })
            }
          })
          .then((response) => {
            // DESCRIPTION:
            // In this part the new currentSettingsProfileId is set & the remote settings are updated
            // "recursive" means that updateAppSettingsRemotely was called recursively to update remote & local settings
            // The reason for this is not avoid code duplication. You can see the updateAppSettingsRemotely() being called again below
            if (requestStatus === "404" && response.data && !recursive) {
              localStorage.setItem(
                  "currentSettingsProfileId", // TODO see where & how currentSettingsProfileId is used
                  response.data.id
              );

              this.updateAppSettingsRemotely({
                settings: settings,
                recursive: true,
              });
            }
          })
          .catch((error) => {
            // DESCRIPTION:
            // In this part a new pageState config is being created & currentSettingsProfileId is set inside the postNewSetting()
            // CASE:
            // This catches a case where "SettingsService.getMe" above returned an error
            if (
                error.hasOwnProperty("message") &&
                error.message.search("404") !== -1
            ) {
              this.postNewSetting(false, settings);
            }
          });
    },
    applyDesktopProfile(fetchDesktopProfile = true) {
      if (fetchDesktopProfile) {
        SettingsService.getMe({params: {device: "Desktop"}})
            .then((response) => {
              if (response.data) {
                let profile = response.data;
                this.selectedProfile = profile;
                this.settingsProfileExists = true;
                let settings = this.completeSettingsBackwardCompatibility(
                    profile.configuration
                );
                settings.device = "Desktop";
                this.updateSettings(settings);
                localStorage.setItem(
                    "currentSettingsProfileId", // TODO see where & how currentSettingsProfileId is used
                    profile.id
                );
                localStorage.setItem("selected-device-type", settings.device);
              }
            })
            .catch((error) => {
              if (typeof error == "object") {
                if (error.response && error.response.status) {
                  console.error(error);
                }
              }

              // Make sure that it was a request error (wasn't caused by a bug in the code)
              if (
                  error.hasOwnProperty("message") &&
                  error.message.search("Request failed with status code") !== -1
              ) {
                this.postNewSetting(false, defaultSettings);
              }

              this.updateSettings(defaultSettings);
              localStorage.setItem("selected-device-type", "Desktop");
            })
            .finally(() => {
              this.applyAppState();
              this.settingsLoaded = true;
            });
      } else {
        this.postNewSetting();
        this.updateSettings(defaultSettings);
        localStorage.setItem("selected-device-type", "Desktop");
      }
    },
    applySelectedProfile(profile) {
      this.settingsProfileExists = true;
      this.selectedProfile = profile;
      this.updateSettings(JSON.parse(JSON.stringify(profile.configuration)));
      this.applyAppState();
      localStorage.setItem("currentSettingsProfileId", profile.id);
    },
    newProfileCreated() {
      this.refreshUserProfiles();
      if (this.noProfilesExist) this.noProfilesExist = false;
    },
    deleteUnsavedProfile(device) {
      this.configurationProfiles = this.configurationProfiles.filter(
          (el) => el.configuration.device !== device
      );
    },
    showProfileSelection(fetchProfiles = false) {
      if (fetchProfiles) {
        SettingsService.get()
            .then((response) => {
              if (response.data && response.data.length) {
                // let profiles = response.data
                // let profiles = response.data.sort((a,b) => (a.configuration.device == "Desktop") ? 1 : ((b.last_nom > a.last_nom) ? -1 : 0))
                let profiles = response.data.sort((a, b) => {
                  let deviceAEnum = this.deviceSortEnum[a.configuration.device];
                  let deviceBEnum = this.deviceSortEnum[b.configuration.device];
                  if (deviceAEnum > deviceBEnum) return 1;
                  else if (deviceAEnum < deviceBEnum) return -1;
                  else return 0;
                });
                // Make all configs backward compatible
                this.configurationProfiles = profiles.map((profile, index) => {
                  profile.configuration =
                      this.completeSettingsBackwardCompatibility(
                          JSON.parse(JSON.stringify(profile.configuration))
                      );
                  return profile;
                });
                // this.configurationProfiles = profiles;
                this.profileSelectionDialog = true;
              } else {
                this.postNewSetting(true);
                this.updateSettings(defaultSettings);
                this.noProfilesExist = true;
                // if (!this.profileSelectionDialog)
                //   this.profileSelectionDialog = true;
              }
              this.settingsLoaded = true;
            })
            .catch((error) => {
              this.settingsLoaded = true;
              if (this.isAdmin) console.error(error);
              this.$notifier.error(
                  "Couldn't fetch settings profiles.. Using default."
              );
            });
      }
      // else this.profileSelectionDialog = true;
    },
    includesInCurrentAgentIds(checkId) {
      return this.currentTableAgentIds.includes(checkId);
    },
    analyticsTabChange(ids) {
      this.currentTableAgentIds = ids;
    },
    dismissAppUpdate() {
      this.appUpdateAvailable = !this.appUpdateAvailable;
    },
    updateApp() {
      console.log("Updating Dealio...");
      // Cancel all axios requests
      source.cancel("Operation canceled, updating the app..");
      // Close sse
      if (sse && sse.close) sse.close();
      // Show loading animation
      this.loadingAppUpdate = true;

      if (iOS()) window.location.reload();
      else {
        try {
          // Activate the new service worker
          if (channel) channel.postMessage("updateApp");
          else {
            console.error("BroadcastChannel instance is " + channel);
          }
          // Retry activation in 5 sec
          setTimeout(() => {
            if (channel) channel.postMessage("updateApp");
          }, 5000);
          // SW had 5+1sec for skipwaiting() to run with no requests going through SW
          // so consider there was an issue with updating
          setTimeout(() => {
            // Unblock axios requests
            refreshCancelToken();
            // Show to user that there was an issue updating...
            this.loadingAppUpdateFailed = true;
            this.reconnectSSE({});
          }, 10000);
        } catch (error) {
          console.error(error);
        }
      }
    },
    setNewSettings(configuration) {
      let settings = this.completeSettingsBackwardCompatibility(configuration);
      this.updateSettings(settings);
    },
    checkSSEConnectivity() {
      if (this.lastPingReceived == null) {
        this.lastPingReceived = 0;
      }

      if (this.lastPingReceived === 0) {
        this.lastPingReceived = Date.now();
      }

      // Consider connected while updating the app version..
      if (this.loadingAppUpdate && !this.loadingAppUpdateFailed) {
        this.lastPingReceived = Date.now();
      }

      let lastPing = Date.now() - this.lastPingReceived;

      // Last ping was more than 10sec ago && sse connection is not open (is closed or connecting)
      let pingAbsenceLimit = 35000;
      let logSSEState = false;
      try {
        let setting = this.getSpecificSetting({
          section: "general",
          innerSection: "sse",
        });

        if (
            typeof setting == "object" &&
            setting.hasOwnProperty("pingAbsenceLimit")
        ) {
          if (!isNaN(setting.pingAbsenceLimit)) {
            pingAbsenceLimit = setting.pingAbsenceLimit;
          }
        }
        if (setting.hasOwnProperty("logSSEState")) {
          logSSEState = setting.logSSEState;
        }
      } catch (error) {
        console.error(error);
      }
      if (logSSEState) {
        let seperatingDots = "....................................";
        console.log(seperatingDots);
        if (sse && sse.readyState)
          console.log(`SSE Ready State : ${sse.readyState()}`);
        else {
          if (sse) {
            console.log("SSE Ready State is unavailable, sse object :");
            console.log(sse);
          } else
            console.log(
                `SSE Ready State is unavailable, sse object is ${typeof sse}`
            );
        }
        console.log(`Last ping received : ${lastPing}ms ago.`);
        console.log(`Ping absence limit : ${pingAbsenceLimit}ms.`);
        console.log(seperatingDots);
      }
      if (
          lastPing > pingAbsenceLimit &&
          !(sse && sse.readyState && sse.readyState() === 1)
      ) {
        new Promise(async function (resolve, reject) {
          localStorage.setItem("connection-lost", "1");
          resolve();
        }).then(() => {
          this.connectionLost = true;
        });
      }
    },
    connectionIconBlink(event) {
      let connectionBlinkInterval = setInterval(() => {
        let element = document.getElementById("no-connection-icon");
        if (element) {
          if (element.style.color === "rgb(244, 67, 54)") {
            element.style.color = "rgb(255, 255, 255)";
          } else {
            element.style.color = "rgb(244, 67, 54)";
          }
        }
        if (!this.connectionLost) {
          clearInterval(connectionBlinkInterval);
        }
      }, 700);
    },
    refreshExpToken() {
      this.sessionExpired = true;
      AuthenticationService.refresh()
          .then((res) => {
            this.sessionExpired = false;
            axios.defaults.headers.common[
                "Authorization"
                ] = `Bearer ${res.headers.authorization}`;
            this.setJWTInMemory(res.headers.authorization);
            this.setExpirationTime();
            this.loadingAccessTokenDone = true;
          })
          .catch((err) => {
            return AuthenticationService.logout();
          })
          .then(() => {
            // Else means refresh token is expired & logout() succesful so -> log user out locally
            if (this.sessionExpired) this.logoutLocal();
          });
    },
    handleServerEvent(data) {
      switch (data.type) {
        case "PING":
          this.handleServerPing();
          break;
        case "ERROR":
          this.$notifier.error(data.message, {
            type: NOTIFICATION_TYPES.SERVER_EVENT,
          });
          break;
        case "INFO":
          this.$notifier.info(data.message, {
            type: NOTIFICATION_TYPES.SERVER_EVENT,
          });
          break;
        case "DEBUG":
          this.$notifier.warn(data.message, {
            type: NOTIFICATION_TYPES.SERVER_EVENT,
          });
          break;
        default:
          this.$notifier.info(data.message, {
            type: NOTIFICATION_TYPES.SERVER_EVENT,
          });
      }
    },
    errorStatusBetween(err, startNum, endNum) {
      return (
          (err.hasOwnProperty("status") && err.status >= startNum) ||
          err.status <= endNum
      );
    },
    async setupEventSource() {
      try {
        const refinedBaseURI = refineBaseURI();  // Check for client name presence in URL

        console.debug(
            `Connecting to ${refinedBaseURI}/events for SSE`
        );

        sse = await this.$sse(refinedBaseURI + "/events", {
          jwt: accessToken,
        });

        sse.subscribe("", (data) => {
          console.warn("Received a message w/o an event", data);
        });

        sse.subscribe("AgentEvent", (data) => {
          if (!this.fetchingANs && this.currentPage !== "/applications") {
            if (
                data.data.status === "RUN" ||
                data.data.status === "TERMINATED" ||
                data.data.status === "EXITED"
            ) {
              this.refreshApplicationInstances();
            }
          }
        });

        sse.subscribe("server", (data) => {
          this.handleServerEvent(data);
        });

        sse.subscribe("TradeWatcher", (newAlert) => {
          if (!this.tradeWatcherMute) this.play("trade_watcher_alert");

          this.$notifier.info(`New ${newAlert.title} alert!`, {
            type: NOTIFICATION_TYPES.TW_ALERT,
            goToPage: "/trade-watcher",
            alertId: newAlert.id,
          });
          this.updateAlerts(newAlert);
          this.updateTWViewAlerts(false, newAlert.alertCardId);
        });

        sse.subscribe("Analytics", (payload) => {
          let agentId;
          if (Array.isArray(payload))
            agentId = parseInt(payload[0].substring(2));
          else agentId = parseInt(payload.identity.substring(2));
          let tabletype;
          if (Array.isArray(payload)) {
            tabletype = payload[1];
          } else {
            tabletype = payload.source;
          }

          let analyticsSettings = this.getSpecificSetting({
            section: "applications",
            innerSection: "analytics",
          });
          let positionLogs =
              analyticsSettings && analyticsSettings.positionLogs;

          if (positionLogs) {
            console.log(
                `New analytics data of length ${
                    Array.isArray(payload) ? payload[2].length : payload.data.length
                }. Agent ID : ${agentId}. Table: ${tabletype}`
            );
            console.log(payload);
          }

          if (this.includesInCurrentAgentIds(agentId)) {
            messageService.sendMessage(payload);
          }
        });

        sse.subscribe("PriceGuard", (payload) => {
          this.handlePGPayload(payload);
        });

        sse.subscribe("PriceWatcher", (payload) => {
          this.handlePWPayload(payload);
        });

        sse.subscribe("ServerEvents", (payload) => {
          this.fetchApplicationInstances();

          let status = payload.data.status;
          this.setApplicationInstanceStatus(payload);

          let applicationInstance = this.getApplicationInstanceNameByIdentity(
              payload.identity
          );
          if (!applicationInstance) {
            console.log(
                "Application instance does not exist: " + payload.identity
            );
          }

          let name = applicationInstance ? applicationInstance.name : "";

          let message = `Server ${name} is ${
              status === "CONNECTED" ? "now connected" : "disconnected :("
          }`;

          this.$notifier.notify(message, {
            type: NOTIFICATION_TYPES.CONNECTION,
            color: status === "CONNECTED" ? "primary" : "error",
          });

          this.play(`server_${status.toLowerCase()}`);
        });
      } catch (error) {
        // Reconnect sse only if status is 5xx or the connection got closed (by default only 5xx should close the connection)
        if (
            this.errorStatusBetween(error, 500, 599) ||
            (sse && sse.readyState && sse.readyState() === 2)
        ) {
          this.reconnectSSE(error);
        }
      }
    },
    reconnectSSE(error, closeSSE = true) {
      if ((sse || (typeof sse == "object" && sse.close)) && closeSSE) {
        if (error.target) {
          error.target.close(); // close the sse in current scope stack
        } else sse.close();
      }
      setTimeout(() => {
        this.setupEventSource();
      }, 3000);
    },
    updateCurrentEpochTime() {
      this.currentEpochTime = Date.now();
    },
    showPGNotification(newPricesCount) {
      if (this.audioElementListenersSet && !this.priceGuardMute)
        this.play("price_guard_alert");
      let notifyMessage =
          newPricesCount === 1
              ? "New event in PriceGuard"
              : `${newPricesCount} new events in PriceGuard`;

      this.$notifier.info(notifyMessage, {
        type: NOTIFICATION_TYPES.PG_EVENT,
        goToPage: "/price-guard",
      });
    },
    processAndStorePGData(payload) {
      let processedDataObj = PriceguardPreprocessor.preprocess(
          this.getPriceGuardEvents,
          payload,
          this.priceOldAfter,
          this.initialIgnoredPGPrices
      );

      this.updateStoredPGMarketData(processedDataObj.data);

      return processedDataObj.notificationInfo.newPricesCount;
    },
    handlePWPayload(payload) {
      this.updateCurrentEpochTime();
      events.$emit("pw-live-update", payload);
      PriceWatcherMessageService.sendMessage(payload);
    },
    handlePGPayload(payload) {
      if (this.loadingIgnoredItems) return;

      this.updateCurrentEpochTime();

      let newPricesCount = this.processAndStorePGData(payload);

      if (newPricesCount > 0) {
        this.showPGNotification(newPricesCount);
      }
    },
    hideMainWrapperScroll() {
      let element = document.getElementById("main-wrapper");
      if (element && element.hasOwnProperty("style")) {
        element.style.overflowY = "hidden";
      } else {
        let hideScrollInter = setInterval(() => {
          let el = document.getElementById("main-wrapper");
          if (el && el.style) {
            el.style.overflowY = "hidden";
            clearInterval(hideScrollInter);
          }
        }, 500);
      }
    },
    handleAcknowledgeException(error) {
      console.log(error);
      this.$notifier.error("Oops! Couldn't remove the alert", {
        error: error,
      });
    },
    handleException(error) {
      console.log(error);
      this.$notifier.error("Oops! Something went wrong", {
        error: error,
      });
    },
    updateAlertsTotal(options = null) {
      if (options != null && typeof options == "object") {
        // ifAnyExist => Update notification panel only if at least one alert exists (used when deleting alerts history)
        if (options.ifAnyExist && !this.TWAlerts.length) {
          return;
        }
      }
      const notificationsSize = (this.TWAlerts.length < 1 ? 1 : this.TWAlerts.length);
      this.fetchTWNotifications({size: notificationsSize});
    },
    updatePWATheme(dark) {
      let elements = document.getElementsByName("theme-color");
      if (elements.length) {
        elements[0].content = dark ? "#15151a" : "#edeef2";
      }
    },
    handleServerPing() {
      this.lastPingReceived = Date.now();
      if (this.connectionLost) {
        new Promise(async function (resolve, reject) {
          localStorage.setItem("connection-lost", "0");
          resolve();
        }).then(() => {
          this.connectionLost = false;
        });
      }
      // HANDLING TOKEN EXPIRATION (refresh it 1 minute before the expiration)
      if (
          this.getTokenExpirationTime != null &&
          this.getTokenExpirationTime < new Date().getTime() + 60000
      ) {
        this.refreshExpToken();
      }

      // Check if scrolled to the bottom of notifications panel.
      // (Using ping event to keep the code clear of intervals)
      if (this.notificationsPanel) {
        this.isAtBottom = this.checkIfHistoryBottomed();
      }
    },
    rerenderNotifPanel() {
      if (this.notifPanelRenderKey > 10) {
        this.notifPanelRenderKey = 0;
      } else {
        this.notifPanelRenderKey++;
      }
    },
    updateAlerts(alert) {
      let newAlert = JSON.parse(JSON.stringify(alert));
      newAlert.clear = false;
      if (newAlert.createdOn) {
        newAlert.createdOn = this.getHumanReadableTime(newAlert.createdOn);
      }
      if (this.TWAlerts.length && this.TWAlerts.length > 14) {
        this.TWAlerts.pop();
      }
      this.TWAlerts.unshift(newAlert);

      this.TWAlertsTotalLength++;
    },
    clearAnAlertVisually(id, alertToAdd = null) {
      try {
        let alert = this.TWAlerts.find((el) => el.id === id);
        alert.clear = true;

        if (this.TWAlerts.length === 1) {
          setTimeout(() => {
            this.notificationsPanel = false;
          }, 300);
        }
        setTimeout(() => {
          this.TWAlerts = this.TWAlerts.filter((el) => el.id !== id);

          if (alertToAdd != null) {
            this.TWAlerts.push(alertToAdd);
          }
        }, 500);
      } catch (error) {
        this.$notifier.error(
            "Oops! Something went wrong. Please reload the page",
            {error: error}
        );
      }
    },
    clearNotifications() {
      if (this.clearingAllAlerts === true) {
        return;
      }
      this.clearingAllAlerts = true;

      this.alertsToClearLength = this.TWAlerts.length;

      let params = {ids: [0], status: "ACKNOWLEDGED", updateAll: true};

      TradeWatcherService.Alerts.patch(params)
          .then((response) => {
            this.TWAlertsTotalLength = 0;
            this.notificationsPanel = false;
            this.updateTWViewAlerts();
            setTimeout(() => {
              this.alertsToClearLength = 0;
              this.clearingAllAlerts = false;
              this.TWAlerts = [];
            }, 500);
          })
          .catch((err) => {
            console.log(err);
            this.clearingAllAlerts = false;
          });
    },
    acknowledge(id) {
      let params = {ids: [id], status: "ACKNOWLEDGED"};

      TradeWatcherService.Alerts.patch(params)
          .then(() => {
            return this.fecthLastAlert();
          }, this.handleAcknowledgeException)
          .then((response) => {
            if (response) {
              let alertToAdd = null;
              if (!response.data.empty) {
                alertToAdd = response.data.content[0];
                if (alertToAdd.createdOn) {
                  alertToAdd.createdOn = this.getHumanReadableTime(
                      alertToAdd.createdOn
                  );
                }
                alert.clear = false;
              }
              this.clearAnAlertVisually(id, alertToAdd);
              this.acknowledgeAlertOnTWPage(id);
              this.TWAlertsTotalLength--;
            }
          }, this.handleException);
    },
    acknowledgeAlertOnTWPage(id) {
      if (this.$refs.routerView.$options.name === "TradeWatcher") {
        this.$refs.routerView.acknowledgeAlertOnTWPage(id);
      }
    },
    updateTWViewAlerts(scrollTop = true, alertCardId = null) {
      // Used to update the alerts view on TW page
      if (this.$refs.routerView.$options.name === "TradeWatcher") {
        this.$refs.routerView.updateTWAlertsView(scrollTop, alertCardId);
      }
    },
    focusOnAlert(id, index = 0) {
      if (this.$refs.routerView.$options.name === "TradeWatcher") {
        this.$refs.routerView.focusOnAlert({id: id, index: index}, true);
      } else {
        if (this.currentPage !== "/trade-watcher")
          this.$router.push("/trade-watcher");

        let i = 0;
        let switchingRoutes = setInterval(() => {
          if (this.$refs.routerView.$options.name === "TradeWatcher") {
            this.$refs.routerView.focusOnAlert({id: id, index: index}, true);
            clearInterval(switchingRoutes);
          } else if (i > 100) {
            clearInterval(switchingRoutes);
          }
          i++;
        }, 100);
      }
    },
    changeAlertsSort() {
      if (this.alertsSort === ALERT_SORTS.NONE) {
        this.alertsSort = ALERT_SORTS.ASC;
      } else if (this.alertsSort === ALERT_SORTS.ASC) {
        this.alertsSort = ALERT_SORTS.DESC;
      } else {
        this.alertsSort = ALERT_SORTS.NONE;
      }

      this.fetchTWNotifications({size: this.TWAlerts.length});
    },
    showNotificationsPanel() {
      if (this.TWAlerts.length < 3 && !this.notificationsPanel) {
        if (!this.loadingHistory) this.loadMoreHistory();
      }
      this.notificationsPanel = !this.notificationsPanel;
    },
    sameAlertsAsLoaded(newAlerts) {
      // Check if new alerts are the same as existing ones
      return (
          this.TWAlerts.every((el) => {
            return newAlerts.some((alert) => alert.id === el.id);
          }) && this.TWAlerts.length === newAlerts.length
      );
    },
    getHumanReadableTime(epoch) {
      var date;
      try {
        date = new Date(epoch);
      } catch (error) {
        date = new Date();
      }

      let mins =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

      return date.getHours() + ":" + mins;
    },
    fecthLastAlert() {
      let params = {
        minified: true,
        page: this.TWAlerts.length - 1,
        size: 1,
        status: "UNACKNOWLEDGED",
      };

      return TradeWatcherService.Alerts.query({params: params});
    },
    fetchTWNotifications(
        extraParams = null,
        loadMore = false,
        rerender = false
    ) {
      let params = {
        minified: true,
        page: 1,
        size: 15,
        status: "UNACKNOWLEDGED",
      };

      if (this.alertsSort !== ALERT_SORTS.NONE)
        params.sort =
            this.alertsSort === ALERT_SORTS.ASC
                ? "createdOn,asc"
                : "createdOn,desc";

      if (extraParams != null) {
        params = Object.assign(params, extraParams);
      }
      TradeWatcherService.Alerts.query({params: params})
          .then((response) => {
            if (
                this.sameAlertsAsLoaded(response.data.content) &&
                !this.allAlertsLoaded
            ) {
              this.allAlertsLoaded = true;
            }
            if (!response.data.empty) {
              var pageItemsAlreadyLoaded;
              if (this.TWAlerts.length === 0 || this.TWAlerts.length % 15 === 0) {
                pageItemsAlreadyLoaded = 0;
              } else if (params.page) {
                // Here we know that some items from response have to be deleted because they are already loaded
                pageItemsAlreadyLoaded = this.TWAlerts.length - params.page * 14;
                // var itemsAlreadyLoaded = params.page * 32
              }

              let alerts = response.data.content.reduce((final, next) => {
                next.createdOn = this.getHumanReadableTime(next.createdOn);
                next.clear = false;

                if (!loadMore) {
                  final.push(next);
                } else if (pageItemsAlreadyLoaded === 0) {
                  final.push(next);
                } else {
                  if (!this.TWAlerts.some((el) => el.id === next.id)) {
                    final.push(next);
                  }
                }

                return final;
              }, []);

              if (loadMore) {
                this.TWAlerts = this.TWAlerts.concat(alerts);
              } else {
                this.TWAlerts = alerts;
              }

              this.TWAlertsTotalLength = response.data.totalElements;
            } else {
              this.TWAlertsTotalLength = 0;
              this.notificationsPanel = false;
              // setTimeout(() => {
              this.alertsToClearLength = 0;
              this.clearingAllAlerts = false;
              this.TWAlerts = [];
              // }, 500);
            }
            this.loadingHistory = false;

            if (response.data.content.length === params.size) {
              this.lastFetchedAlertsPage = params.page;
            }

            if (rerender) {
              setTimeout(() => {
                this.rerenderNotifPanel();
              }, 450);
            }
          })
          .catch((err) => {
            this.loadingHistory = false;
            console.log(err);
            this.$notifier.warn("Couldn't fetch the latest alerts");
          });
    },
    correctVSnackHeight(stopRecurse = false) {
      let primarySnackBar = document.getElementById("primary-snackbar");
      let secondarySnackBar = document.getElementById("secondary-snackbar");

      if (primarySnackBar)
        primarySnackBar.style.height = this.windowSizeY + "px";

      if (secondarySnackBar)
        secondarySnackBar.style.height = this.windowSizeY + "px";
      else if (!stopRecurse)
        setTimeout(() => {
          this.correctVSnackHeight(true);
        }, 500);
    },
    completeSettingsBackwardCompatibility(settingsUnparsed) {
      var settings;
      if (typeof settingsUnparsed == "string")
        settings = JSON.parse(settingsUnparsed);
      else settings = settingsUnparsed;

      let defaultSet = JSON.parse(JSON.stringify(defaultSettings));

      let settingSections = [
        "general",
        "applications",
        "user",
        "applicationState",
      ];

      settingSections.forEach((section) => {
        let innerSections = Object.keys(defaultSet[section]);
        innerSections.forEach((innerSection) => {
          // If a new section has been added - create it
          if (!settings[section]) {
            settings[section] = {};
          }

          if (typeof defaultSet[section][innerSection] == "object") {
            settings[section][innerSection] = Object.assign(
                defaultSet[section][innerSection],
                settings[section][innerSection]
            );
          } else if (!settings[section].hasOwnProperty(innerSection)) {
            settings[section][innerSection] = defaultSet[section][innerSection];
          }
        });
      });

      if (!settings.hasOwnProperty("device"))
        settings.device = defaultSet.device;

      return settings;
    },
    goToUserSettings() {
      if (this.currentPage === "/settings")
        this.showUserSettings = !this.showUserSettings;
      else
        this.$router.push({path: "/settings", query: {userSettings: true}});
    },
    ignoredPGPricesChange(prices) {
      this.initialIgnoredPGPrices = prices;
    },
    refreshApplicationInstances() {
      this.fetchingANs = true;
      this.fetchApplicationInstances().finally(
          () => (this.fetchingANs = false)
      );
    },
    // DESCRIPTION
    // Applies the generic app settings unasociated with inner applications like Analytics, Priceguard etc.
    // With exception of inner app. settings that are used in App.vue like "Ignored PG prices"
    // e.g mute, theme
    applyAppState() {
      this.applyPGState();

      this.applyTWState();

      let settings = JSON.parse(JSON.stringify(this.getSettings));
      // // settingsLoaded means that vuex has loaded
      // let settingsLoaded = JSON.parse(JSON.stringify(settings.settingsLoaded))

      let mute, dark;
      // Handle any errors or issues with backward compatibility (temporary)
      try {
        mute = settings.applicationState.mute;
        dark = settings.applicationState.dark;
      } catch (error) {
        mute = false;
        dark = true;
      }

      this.$vuetify.theme.dark = dark;

      // If isn't muted but must be
      // OR if is muted but must not be call mute() which handles both cases
      if ((!this.muted && mute) || (this.muted && !mute)) {
        this.mute();
      }
    },
    logoutLocal() {
      this.loggingOut = true;
      setTimeout(() => {
        this.loggingOut = false;
      }, 500);
      setTimeout(() => {
        accessToken = "";
        this.$forceUpdate();
        this.showLoadingScreen = true;
        this.$router.push("/login").catch((err) => {
        });
      }, 400);
    },
    getTokenAndMount() {
      let tempAccessToken;
      const clientUrlString = localStorage?.getItem("client") || null;
      AuthenticationService.refresh({'mounted login': clientUrlString})
          .then((r) => {
            tempAccessToken = r.headers.authorization;
            axios.defaults.headers.common[
                "Authorization"
                ] = `Bearer ${r.headers.authorization}`;
            this.fetchUserSettings();
            // if (window.location.pathname != "/settings") this.fetchUserSettings();
            if (window.location.pathname !== "/analytics")
              this.fetchApplicationInstances();
            return UserService.getUserInfo();
          })
          .then((r) => {
            this.setUserInfo(r.data);
            this.loginUser(tempAccessToken);
            this.loadingAccessTokenDone = true;
          })
          .catch((er) => {
            this.loadingAccessTokenDone = true;
            if (this.currentPage !== "/login") this.$router.push("/login");
          });
    },
    mountMethod() {
      this.setEventListeners();

      this.fetchTWNotifications();

      // // Get previously saved ignored PG prices state
      // localForage.getItem("PGignoredItems", (err, value) => {
      //   if (value != null) {
      //     this.initialIgnoredPGPrices = value;
      //   }
      //   this.loadingIgnoredItems = false;
      // });

      if (!this.isMobileOrTablet)
        document.getElementById("htmlId").style.overflowY = "hidden";

      setTimeout(() => {
        this.soundsDisabled = true;
      }, 500);

      this.onResize();

      this.notificationPage = pushNotificationPage;

      events.$on("plugin-event-source-error", (error) => {
        if (this.errorStatusBetween(error, 500, 599)) {
          this.reconnectSSE(error);
        } else {
          console.log(error);
        }
      });

      events.$on("edit-settings-profile", (error) => {
        this.showProfileSelection(true);
      });

      this.setupEventSource();

      // let analyticsSettings = this.getSpecificSetting({
      //   section: "applications",
      //   innerSection: "analytics",
      // });

      // Check SSE Connectivity every 3 sec
      setInterval(this.checkSSEConnectivity, 3000);
    },
    logout() {
      AuthenticationService.logout()
          .then((r) => {
            this.logoutLocal();
            // This will stop the loading screen of login component
            this.loadingAccessTokenDone = true;
          })
          .catch((e) => {
            this.$notifier.error("Oops! Couldn't log out, please reload Dealio.");
          });
    },
    showLogin() {
      return !accessToken.length;
    },
    setJWTInMemory(jwt, loginUser = false) {
      accessToken = jwt;
    },
    loginUser(jwt, home = false) {
      this.showLoadingScreen = false;
      let parent = this;

      function loginUserHelper() {
        parent.sessionExpired = false;
        parent.setJWTInMemory(jwt, true);
        parent.mountMethod();
        parent.hideMainWrapperScroll(); // This is a workaround for the blinking scroll bar. It happens when you switch between pages.
        if (
            (home && parent.currentPage !== "/") ||
            window.location.pathname === "/login"
        )
          parent.$router.push("/");
      }

      if (home) {
        this.loggingIn = true;
        setTimeout(() => {
          // wait .350 for the transition
          this.loggingIn = false;
          loginUserHelper();
        }, 350);
      } else {
        loginUserHelper();
      }
    },
    loadMoreHistory(wait = false) {
      this.loadingHistory = true;
      this.allAlertsLoaded = false;
      if (this.lastFetchedAlertsPage == null) {
        this.lastFetchedAlertsPage = -1;
      }

      let page = Math.trunc(this.TWAlerts.length / 15);

      if (wait) {
        setTimeout(() => {
          this.fetchTWNotifications({page: page}, true);
        }, 400);
      } else this.fetchTWNotifications({page: page}, true);
    },
    checkIfHistoryBottomed() {
      let notif_history_element = document.getElementById("notif_history");
      let panelHeight = parseInt(
          notif_history_element.style.height.split("p")[0],
          10
      );
      let scrollHeight =
          notif_history_element.scrollTop +
          (isNaN(panelHeight)
              ? parseInt(notif_history_element.style.maxHeight.split("p")[0], 10)
              : panelHeight);

      // scrollHeight is the amount scrolled
      // notif_history_element.scrollHeight is the total scrollable height(space) of the element
      let scrolledCloseToEnd =
          scrollHeight < notif_history_element.scrollHeight &&
          scrollHeight > notif_history_element.scrollHeight - 20;

      let scrolledToEndOrMore =
          scrollHeight >= notif_history_element.scrollHeight; // scrolled to end or more

      return scrolledCloseToEnd || scrolledToEndOrMore;
    },
    onResize() {
      this.windowSizeY = window.innerHeight;
      this.windowSizeX = window.innerWidth;
      if (this.notificationSupported) {
        this.screenOrientationType = screen.orientation.type;
      }
    },
    postNewSetting(showProfileSelection = false, settings = null) {
      SettingsService.post(settings ? settings : defaultSettings)
          .then((response) => {
            // Save the currentSettingsProfileId
            this.selectedProfile = response.data;
            this.settingsProfileExists = true;
            localStorage.setItem("currentSettingsProfileId", response.data.id);
            // response.data && response.data.id usewd to avoid any infinite loop when postNewSetting() is called from showProfileSelection()
            if (showProfileSelection && response.data && response.data.id) {
              this.showProfileSelection(true);
            }
          })
          .catch((error) => {
            console.error(error);
            if (this.isAdmin)
              this.$notifier.error(
                  "Could not create a new setting profile. Please reload Dealio",
                  {error: error}
              );
            else
              this.$notifier.error(
                  "Could not create a new settings profile. Using default settings."
              );
          });
    },
    refreshUserProfiles() {
      SettingsService.get()
          .then((response) => {
            let profiles = response.data.sort((a, b) => {
              let deviceAEnum = this.deviceSortEnum[a.configuration.device];
              let deviceBEnum = this.deviceSortEnum[b.configuration.device];
              if (deviceAEnum > deviceBEnum) return 1;
              else if (deviceAEnum < deviceBEnum) return -1;
              else return 0;
            });
            // let profiles = response.data;
            // Make all configs backward compatible
            this.configurationProfiles = profiles.map((profile) => {
              profile.configuration = this.completeSettingsBackwardCompatibility(
                  JSON.parse(JSON.stringify(profile.configuration))
              );
              return profile;
            });
            this.settingsLoaded = true;
          })
          .catch((error) => {
            this.settingsLoaded = true;
            console.error(error);
            this.$notifier.error("Couldn't refresh user profiles!");
          });
    },
    fetchUserSettings() {
      let selectedDeviceType = localStorage.getItem("selected-device-type");
      if (!selectedDeviceType) {
        if (this.deviceType === "Desktop") {
          // fetchDesktopProfile needed in case the previous SettingsService.getMe call wasnt for a desktop profile
          let fetchDesktopProfile = true;
          this.applyDesktopProfile(fetchDesktopProfile);
        } else {
          this.showProfileSelection(true);
        }

        return;
      }
      let params = {device: selectedDeviceType};
      SettingsService.getMe({params: params})
          .then((response) => {
            if (response.data) {
              // TODO 1  (Very rare case)
              // If you receive a response with a profile
              // but the priofile is for Mobile device meaning
              // that the only profile saved is of mobile device
              // then showProfileSelection witht the mobile profile and an option to create a new one

              // TODO 1
              // If you receive a profile with a different type then the current device then
              // showProfileSelection with option to "use the received profile" or "create a new one for this type of device"
              let profile = response.data;
              this.selectedProfile = response.data;
              this.settingsProfileExists = true;
              let settings = this.completeSettingsBackwardCompatibility(
                  profile.configuration
              );
              // let settings = this.completeSettingsBackwardCompatibility(
              //   profile.configuration
              // );

              settings.device = params.device;
              this.updateSettings(settings);
              this.settingsLoaded = true;
              localStorage.setItem(
                  "currentSettingsProfileId", // TODO see where & how currentSettingsProfileId is used
                  profile.id
              );
              this.applyAppState();
            }
            // else {
            //   // TODO
            //   // If you receive no user profiles and
            //   // its a desktop or laptop device
            //   // then post a new settings profile to the back-end
            //   // that profile will become default
            //   // this.showProfileSelection()
            //   this.postNewSetting();
            //   this.updateSettings(defaultSettings);
            // }
          })
          .catch((error) => {
            this.settingsLoaded = true;
            if (this.isAdmin) console.error(error);
            // this.updateSettings(defaultSettings);

            // If current device is a desktop. Do not show Profile selection dialog
            // But instead just apply/create a Desktop profile
            if (this.deviceType === "Desktop") {
              // fetchDesktopProfile needed in case the previous SettingsService.getMe call wasnt for a desktop profile
              let fetchDesktopProfile = params.device !== "Desktop";
              this.applyDesktopProfile(fetchDesktopProfile);
            } else {
              this.showProfileSelection(true);
            }
          });
    },
    openApplicationPage(page) {
      if (this.notificationSupported) {
        if (
            !this.notificationRequestAccepted &&
            Notification.permission !== "denied"
        ) {
          Notification.requestPermission();
        }
      }

      this.$router.push(page).catch((err) => {
      });
    },
    changeAnalyticsColor({isEmpty}) {
      this.analyticsIsEmpty = isEmpty;
    },
    assignDataExpiring(value) {
      this.removeExpiredData = value;
      let options = {
        section: APP_STATE_SECTIONS.PRICEGUARD,
        innerSection: "expiring",
        mutation: value,
      };
      this.updateAppStateRemotelyAndLocally(options);
      // TODO
      // Save expiring state to user profile settings
    },
    toggleDrawer() {
      this.lgAndUp
          ? this.$store.commit("setOpposite")
          : this.$refs.drawerLayout.toggle(true);
    },
    /**
     * Extract the client string and store the required string value accordingly
     */
    handleClientVersion() {
      const hostName = window?.location?.hostname.split('.');
      // console.log('hostName', hostName);
      const clientString = hostName.length > 2 ? hostName[0] : null;
      // console.log('clientString', clientString);
      if (!!clientString && (clientString.length > 0)) {
        localStorage.setItem("client", clientString);
      }
    },
    ...mapMutations(["expireStoredPrices", "updateStoredPGMarketData"]),
    ...mapMutations("instances", ["setApplicationInstanceStatus"]),
    ...mapActions("instances", ["fetchApplicationInstances"]),
    ...mapMutations(["updateApplicationState"]),
    ...mapMutations(["clearMarketData"]),
    ...mapMutations(["updateSettings"]),
    ...mapMutations(["setUserInfo"]),
    ...mapMutations(["setExpirationTime"]),
    ...mapMutations(["updateSpecificSetting"]),
    ...mapMutations(["minifyNavDrawer"]),
  },
  beforeCreate() {
    localStorage.removeItem("connection-lost");
  },
  created() {
    setTimeout(() => {
      this.showLoadingScreen = true;
      setTimeout(() => {
        this.loginTransitionDelay = true;
      }, 100);
    }, 200);

    events.$on("sw-updated", () => {
      this.appUpdateAvailable = true;
    });

    this.$router.beforeEach((to, from, next) => {
      // pageReloaded helps distinguish between route change & page reload
      if (this.pageReloaded) this.pageReloaded = false;
      let loggedIn = accessToken.length;
      if (to.path !== "/login") {
        if (!loggedIn) {
          next("/login");
        } else {
          next();
        }
      } else {
        if (!loggedIn) {
          next();
        } else {
          next("/");
        }
      }
    });

    document.getElementById("htmlId").style.height = "100%";
    document.getElementById("bodyId").style.height = "100%";

    setInterval(() => {
      if (this.getPriceGuardEvents.length) {
        this.expireStoredPrices({
          dataExpirationCycle: this.dataExpirationCycle * 1000,
          removeExpiredData: this.removeExpiredData,
          removeExpiredDataAfter: this.removeExpiredDataAfter * 1000,
        });
      }
    }, 3000);

    window.addEventListener("beforeunload", function (event) {
      localStorage.removeItem("connection-lost");
      if (sse) {
        sse.close();
      }
      if (channel) {
        channel.close();
      }
    });
  },
  mounted() {
    this.handleClientVersion();
    let focusOnAlert = this.focusOnAlert;
    let parentRouter = this.$router;
    let currentPage = this.currentPage;

    if (channel) {
      channel.onmessage = function (e) {
        try {
          switch (e.data.type) {
            case "tw-alert-focus":
              focusOnAlert(e.data.alertId);
              break;
            case "change-route":
              if (currentPage !== e.data.route) parentRouter.push(e.data.route);
          }
        } catch (error) {
        }
      };
    }

    if (this.notificationSupported) {
      if (Notification.permission === "denied") {
        this.notificationsForbidden = true;
      }
    }

    if (!this.isMobileOrTablet)
      document.getElementById("htmlId").style.overflowY = "hidden";

    events.$on("focus-on-new-alert", (id) => this.focusOnAlert(id));

    this.getTokenAndMount();
  },
  beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
    if (sse) {
      sse.close();
    }
  },
  watch: {
    connectionLost(value) {
      if (value) {
        this.play("action_failed");
        if (pageIsHidden())
          this.$notifier.info(
              `Lost connection to the server! Alerts won't be shown!`
          );
        this.connectionIconBlink();
      }
    },
    notificationsPanel(value) {
      if (!value) {
        this.fetchTWNotifications(null, false, true);
      }
    },
    screenOrientationType() {
      this.correctVSnackHeight();
    },
    muted(v) {
      this.updateAppStateRemotelyAndLocally({
        section: APP_STATE_SECTIONS.MUTE,
        mutation: v,
      });
    },
    isAtBottom(v) {
      if (v && !this.loadingHistory) {
        this.loadMoreHistory();
      }
    },
    $route(to, from) {
      // Purpose for the following:
      // To execute shortcuts(if exist) of the page that was entered.
      // But only once that page hits the created() stage

      this.currentPage = window.location.pathname;
    },
    lgAndUp() {
      if (this.$refs.drawerLayout) this.$refs.drawerLayout.toggle(false);
    },
    notificationPage: {
      handler(val) {
        if (
            val.location !== undefined &&
            val.location !== "" &&
            val.handled === false &&
            val.location !== window.location.pathname
        ) {
          this.$router.push(val.location).catch((err) => {
          });
          val.handled = true;
        }
      },
      deep: true,
    },
  },
};

function iOS() {
  return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

function pageIsHidden() {
  return (
      document.hidden ||
      document.msHidden ||
      document.webkitHidden ||
      document.mozHidden
  );
}
</script>
<style lang="scss">
@import "./css/utilities/override-scroll-bar/scrlBarDark.css";
</style>
<style lang="scss">
@import "./css/utilities/override-scroll-bar/scrlOutsideDealio.css";
</style>
<style>
.fade-enter-active {
  -webkit-animation: pageTransitionOpacity 0.6s ease-in-out forwards;
  animation: pageTransitionOpacity 0.6s ease-in-out forwards;
}

.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

@keyframes pageTransitionOpacity {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  60% {
    opacity: 0;
  }
  70% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}

::-webkit-scrollbar-button:single-button {
  height: 0;
  width: 0;
}

@import url("./css/utilities/globalCSS.css");
@import url("./css/dealio.scss");
</style>
<style scoped>
.app-border-light {
  border-right: 1px solid white;
}

.toolbar-left, .toolbar-center, .toolbar-right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

@import "./css/utilities/app.css";

.theme--dark .app-bar {
  background-color: #1c6e59 !important;
}

.theme--light .app-bar {
  background-color: #47bd96 !important;
}

div[role="menu"] {
  border-radius: 0 0 4px 4px;
}

@import url("./css/dealio.scss");
</style>
